"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _MailerSend = /*#__PURE__*/ _interop_require_default(require("./MailerSend"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let MailerSendPlugin = class MailerSendPlugin extends _ncplugin.XcEmailPlugin {
    getAdapter() {
        return MailerSendPlugin.storageAdapter;
    }
    async init(config) {
        MailerSendPlugin.storageAdapter = new _MailerSend.default(config);
        await MailerSendPlugin.storageAdapter.init();
    }
};
const _default = MailerSendPlugin;
